var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6673 8.50016C14.6673 12.1821 11.6825 15.1668 8.00065 15.1668C4.31875 15.1668 1.33398 12.1821 1.33398 8.50016C1.33398 4.81826 4.31875 1.8335 8.00065 1.8335C11.6825 1.8335 14.6673 4.81826 14.6673 8.50016ZM5.9804 6.47993C6.17567 6.28467 6.49225 6.28467 6.68751 6.47993L8.00063 7.79305L9.31374 6.47994C9.509 6.28468 9.82558 6.28468 10.0208 6.47994C10.2161 6.67521 10.2161 6.99179 10.0208 7.18705L8.70774 8.50016L10.0208 9.81325C10.2161 10.0085 10.2161 10.3251 10.0208 10.5204C9.82557 10.7156 9.50898 10.7156 9.31372 10.5204L8.00063 9.20726L6.68752 10.5204C6.49226 10.7156 6.17568 10.7156 5.98042 10.5204C5.78516 10.3251 5.78516 10.0085 5.98042 9.81326L7.29352 8.50016L5.9804 7.18704C5.78514 6.99177 5.78514 6.67519 5.9804 6.47993Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleFill);
export default __webpack_public_path__ + "static/media/closeCircleFill.1d3a471fcd1d6155b48851e9644a59a4.svg";
export { ForwardRef as ReactComponent };